// extracted by mini-css-extract-plugin
export default {"container":"feed-item_container__PCvc5","line":"feed-item_line__J3ZUX","list":"feed-item_list__UW8sa","number":"feed-item_number__zY+43"};